import appCONST from './../../../constants/app.constants';

export default function AdminHotelViewService(
    $http,
    $window,
    l10nService
) {
    'ngInject';

        const HOTEL_DETAILS_URL = '/management/hotels/';
        const HOTELS_UNMERGE_URL = '/management/hotels/unmerge';

        Object.assign(this, {
            getHotelProfile,
            unmergeHotels,
            showUnmergeConfirmationDialog,
        });

        function showUnmergeConfirmationDialog() {
            const unmergeConfirmationMsg = 'Are you sure you want to unmerge this Hotel Profile?';
            return $window.confirm(l10nService.localize(unmergeConfirmationMsg));
        }

        function getHotelProfile(hotelId) {
            const url = `${appCONST.apiUrl}${HOTEL_DETAILS_URL}${hotelId}`;

            return $http.get(url)
                .then(({data: {hotel}}) => hotel);
        }

        function unmergeHotels(id) {
            const url = `${appCONST.apiUrl}${HOTELS_UNMERGE_URL}?profileId=${id}`;
            return $http.post(url)
                .then(({data}) => data);
        }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-hotel-view/admin-hotel-view-service.js